import { render, staticRenderFns } from "./PerfilEditDadosEndereco.vue?vue&type=template&id=b8f12024"
import script from "./PerfilEditDadosEndereco.vue?vue&type=script&lang=ts"
export * from "./PerfilEditDadosEndereco.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports